import React, { Component }  from 'react'
import _ from 'lodash'

import { getProjects } from '../../api/butterCMS'
import { ContentScroller } from '../'
import ProjectLink from '../Project/ProjectLink'

class RelatedProjects extends Component {

    constructor(props) {
        super(props)

        this.state = {
            relatedProjects: []
        }
    }

    componentDidMount() {
        this.getRelatedProjects()
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.originProject, this.props.originProject)) {
            this.getRelatedProjects()
        }
    }

    getRelatedProjects() {
        const { originProject } = this.props
    
        getProjects({ page_size: 10 }).then(({data}) => {
            const { projects } = data

            // get current project index
            const currentProjectIndex = _.findIndex(projects, p => { return p.slug === originProject.slug })
            const relatedProjects = _.concat(
                _.slice(projects, currentProjectIndex+1),
                _.slice(projects, 0, currentProjectIndex)                
            )

            this.setState({
                relatedProjects
            })
        })
    }

    render() {
        const { relatedProjects } = this.state

        if (!relatedProjects) {
            return null
        }

        return (
            <ContentScroller isCentered={true}>
                {relatedProjects.map((project, k) => {
                    return <ProjectLink project={project} key={k} />
                })}
            </ContentScroller>
        )
    }
}

export default RelatedProjects


// WEBPACK FOOTER //
// ./src/components/Project/RelatedProjects.js